/** HTTP base URL for REST calls (mirrors SocketContext server URL logic). */
export function getServerHttpBase(): string {
  const fromEnv = import.meta.env.VITE_SERVER_URL as string | undefined;
  if (fromEnv?.trim()) {
    let base = fromEnv.trim();
    if (base.startsWith('ws://')) base = `http://${base.slice(6)}`;
    else if (base.startsWith('wss://')) base = `https://${base.slice(6)}`;
    return base.replace(/\/$/, '');
  }
  const hostname = window.location.hostname;
  const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
  return `${protocol}//${hostname}:3000`;
}
